import React from 'react';
import { FormikSelect } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';
import statesItems from 'components/AddressFields/StateSelect/data';
import getDropdownParentWithoutDetaching from 'utilities/getDropdownParentWithoutDetaching';

const StateField = () => {
  return (
    <FormField label="State" htmlFor="state">
      <FormikSelect
        id="state"
        name="address.state"
        items={statesItems}
        placeholder="Select"
        getPopupContainer={getDropdownParentWithoutDetaching}
      />
    </FormField>
  );
};

export default StateField;
